import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { Loading, Toast } from 'antd-mobile';
import { GlobalLoadingContext } from 'App';
import { useContext, useEffect, useState } from 'react';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import PayOrderApi, { PayOrderDataType } from 'services/apis/usr/pay-order';
import { merchantKey } from 'services/request';
import { getPlatform, isNative } from 'utils/updateManagerRemote';
import { getSign, VPayRequestDT } from 'utils/vPayUtils';

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [queryParams, setQueryParams] = useState<QueryParams>(null);
  const [vPayData, setVPayData] = useState<VPayRequestDT>(null);
  const [success, setSuccess] = useState(null);
  const showGlobalLoading = useContext(GlobalLoadingContext)?.showGlobalLoading;

  const checkPayStatus = async () => {
    // 解析 URL 参数
    const searchParams = new URLSearchParams(location.search);
    const params: Partial<QueryParams> = {};

    // 遍历所有参数并加入对象
    for (let [key, value] of searchParams.entries()) {
      params[key as keyof QueryParams] = decodeURIComponent(value);
    }
    // 设置解析后的参数
    setQueryParams(params as QueryParams);

    console.log('params', params);

    const tradeNo = params.trade_no;
    setVPayData({
      merchantPid: params.pid,
      merchantKey: merchantKey,
      payType: params.type,
      outTradeNo: params.out_trade_no,
      productName: params.name,
      productMoney: Number(params.money),
      notifyUrl: decodeURIComponent(params.notify_url),
      returnUrl: decodeURIComponent(params.return_url),
      signType: params.sign_type,
    });

    const payResp = await PayOrderApi.getBySystemTradeNo(tradeNo);
    const result: PayOrderDataType = payResp.result;
    if (!payResp.successful || result?.isComplete != 1) {
      Toast.show('未检测到支付, 补单请联系管理员');
      setSuccess(false);
    } else {
      setSuccess(true);
      setTimeout(() => {
        exitOrReload();
      }, 10 * 1000);
    }
  };

  const exitOrReload = () => {
    // window.history.back();
    // 方法一
    // window.location.href = 'about:blank';
    // window.close();
    // 方法二
    // window.opener = null;
    // window.open('about:blank', '_top').close();
    // 方法三
    if (navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
      window.location.href = 'about:blank';
      window.close();
    } else {
      window.opener = null;
      window.open('', '_self');
      window.close();
    }
    if (isNative()) {
      LiveUpdate.reload();
    } else {
      // window.parent：获取父window的引用
      window.parent.location.href = '/';
    }
  };

  useEffect(() => {
    // 隐藏按钮 取消支付
    const btn = window.parent.document.getElementById('cancelPay');
    if (btn?.style) {
      btn.style.visibility = 'hidden';
    }
    showGlobalLoading && showGlobalLoading({ long: true });
    checkPayStatus();
  }, [location.search]);

  // 查询参数的类型
  type QueryParams = {
    orderId: string;
    money: string;
    name: string;
    notify_url: string;
    out_trade_no: string;
    pid: string;
    return_url: string;
    trade_no: string;
    trade_status: string;
    type: string;
    sign: string;
    sign_type: string;
  };

  // 页面内容
  return (
    <div
      className=" flex flex-col items-center justify-center bg-white rounded-md shadow-md text-[22px] z-10"
      style={{
        width: window.innerWidth * 0.75,
        aspectRatio: 1,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className=" scale-110 text-center">
        {success == null || success == undefined ? (
          <div className=" flex justify-center items-center gap-2 text-xl">
            正在检测
            <Loading />
          </div>
        ) : success ? (
          <div className=" flex justify-center items-center gap-2 text-xl text-[#66cc66] font-bold">
            已支付
            <AiFillCheckCircle />
          </div>
        ) : (
          <div className=" flex justify-center items-center gap-2 text-xl text-[#cc6666] font-bold">
            未支付
            <AiFillCloseCircle />
          </div>
        )}
        {/* 升级用户组 */}
        {success && (
          <div className=" bg-gradient-to-r bg-clip-text from-violet-500 to-fuchsia-500 text-xl text-transparent font-extrabold mt-4">
            已升级 {queryParams.name?.split(':')[1]}
          </div>
        )}
        {/* 交互按钮 */}
        {success != null && success != undefined && !success && (
          <div>
            <div
              onClick={() => {
                setSuccess(null);
                // showGlobalLoading && showGlobalLoading({ long: true });
                setTimeout(() => {
                  checkPayStatus();
                }, 3000);
              }}
              className=" mt-10 w-48 text-center p-4 rounded-md shadow-md bg-orange-400 text-white"
            >
              重新检测
            </div>
            <div
              onClick={async () => {
                // React Router 刷新当前页面
                if (navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
                  window.location.href = 'about:blank';
                  window.close();
                } else {
                  // window.opener = null;
                  // window.open('', '_self');
                  // window.close();
                  await LiveUpdate.reload();
                }
              }}
              className=" mt-5 w-48 text-center p-4 rounded-md shadow-md bg-sky-400 text-white"
            >
              返回首页
            </div>
            <div
              className=" underline underline-offset-4 text-sm mt-8 text-center"
              onClick={() => {}}
            >
              * 补单请联系管理员 *
            </div>
          </div>
        )}
        {/* 立即返回 */}
        {success && (
          <div
            className=" underline underline-offset-4 text-sm mt-8"
            onClick={() => {
              exitOrReload();
            }}
          >
            10秒后返回，点击立即返回
          </div>
        )}
        {/* 支付参数详情 */}
        {false && queryParams && (
          <div className=" text-xs">
            <h2>支付信息:</h2>
            <pre>{queryParams ? JSON.stringify(queryParams, null, 2) : '加载中...'}</pre>
            <pre>{queryParams.sign === getSign(vPayData) ? 'sign校成功' : 'sign校验失败'}</pre>
          </div>
        )}
      </div>
    </div>
  );
};
export default Success;
